<template>
	<div
		v-editable="blok"
		class="py-3 px-4 border border-border-tertiary rounded-2.5xl shadow-green-sm"
	>
		<button
			type="button"
			class="flex items-center justify-between w-full gap-4 font-semibold text-left focus-outline"
			@click.prevent="toggle"
		>
			{{ blok.title }}
			<NuxtIcon
				name="chevron-down"
				class="text-3xl text-icon-primary transition"
				:class="{'scale-y-[-1]': isOpen}"
				filled
			/>
		</button>
		<ExpandTransition :appear="true">
			<div v-show="isOpen">
				<div class="pt-3 pb-2 sm:pb-3">
					<hr class="border-t-2 border-border-tertiary pb-3 sm:pb-6" />
					<div :class="{'sm:flex gap-4 sm:gap-10': blok.image?.filename}">
						<div v-if="blok.image?.filename" class="basis-1/2 flex justify-center max-sm:mb-4">
							<NuxtPicture
								class="rounded-2.5xl object-cover"
								provider="storyblok"
								width="466"
								height="484"
								:src="blok.image.filename"
								:srcset="blok.image.filename"
								:alt="blok.image.alt || ''"
								:modifiers="storyblokFocusModifiers(blok.image.focus)"
								:img-attrs="{class:'rounded-2.5xl object-cover'}"
								loading="lazy"
							/>
						</div>
						<RichText :data="blok.content" :class="{'basis-1/2': blok.image?.filename}" />
					</div>
				</div>
			</div>
		</ExpandTransition>
	</div>
</template>
<script setup lang="ts">
	import {set} from '@vueuse/core';
	import ExpandTransition from '~/components/ExpandTransition.vue';
	import type {AccordionStoryblok} from '@/storyblok/types';

	interface Props {
		blok: AccordionStoryblok
	}

	defineProps<Props>();

	const isOpen = ref<boolean>(false);

	const toggle = () => {
		set(isOpen, !isOpen.value);
	};
</script>
